import { RouteObject } from 'react-router-dom';
import { GroupManagement } from './views/GroupManagement';

export const groupRoutes: RouteObject[] = [
    {
        path: '/admin/nub/groups',
        element: <GroupManagement />,
    }
];
